<style scoped>
.this__icon {
  width: 10px;
}
</style>
<template>
  <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    class="demo__FormModal demo__FormModal--v2 demo__align-left demo__margin-top--24"
    data-testid="reg-step1"
  >
    <a-form-model-item
      ref="phone"
      prop="phone"
      :label="$t('Phone')"
      class="demo__FormModal--required"
    >
      <IntlTelInputWithUtils
        :options="{
          separateDialCode: true,
          strictMode: true,
          i18n: { ...lang },
          fixDropdownWidth: true,
          useFullscreenPopup: false,
        }"
        :inputProps="{
          required: true,
        }"
        @changeNumber="
          form.phone = $event;
          $nextTick(() => validatePhone());
        "
        @changeErrorCode="errorCode = $event"
        @changeValidity="isPhoneValid = $event"
        data-testid="reg-phone"
      />
      <div v-if="phoneError" class="demo__FormModal--result">
        {{ phoneError }}
      </div>
    </a-form-model-item>

    <a-form-model-item
      ref="email"
      prop="email"
      :label="$t('Email')"
      class="demo__FormModal--required demo__margin-top--16"
      :validate-status="emailLoading ? 'validating' : ''"
      :has-feedback="emailLoading"
    >
      <a-input
        v-model="form.email"
        data-testid="reg-email"
        autocomplete="off"
        class="demo__input"
        @blur="
          () => {
            $refs.email.onFieldBlur();
          }
        "
      />
    </a-form-model-item>
    <a-form-model-item
      ref="password"
      prop="password"
      autocomplete="off"
      :label="$t('Password')"
      class="demo__margin-top--16 demo__FormModal--required"
    >
      <a-input-password
        v-model="form.password"
        data-testid="reg-password"
        class="demo__input--password"
      />
    </a-form-model-item>
    <a-form-model-item>
      <div>
        <div
          class="demo__flex demo__flex-middle demo__margin-top--8 demo__font--11 demo__weight--400"
          v-for="rule in passwordRules"
          :key="rule.label"
        >
          <i
            class="fa-light this__icon"
            v-bind:class="{
              'fa-xmark': !rule.valid,
              'fa-check demo__color--textSecondaryGreenDark': rule.valid,
            }"
          ></i>
          <div class="demo__margin-left--10">
            {{ rule.label }}
          </div>
        </div>
      </div>

      <div class="demo__margin-top--16">
        <div
          class="demo__flex demo__flex-middle demo__pointer"
          data-testid="reg-agree"
        >
          <a-checkbox
            v-model="imAgree"
            class="demo__Checkbox--big demo__Checkbox--white demo__margin-right--9"
          >
          </a-checkbox>
          <div
            class="demo__font--11 demo__weight--500 demo__color--black demo__line-height--normal"
          >
            {{ $t("Auth access 1") }}
            <a :href="userLinks.personalData" target="_blank">{{
              $t("Auth access 2")
            }}</a>
            {{ $t("Auth access 3") }}
            <a :href="userLinks.privacyPolicy" target="_blank">{{
              $t("Auth access 4")
            }}</a>
            {{ $t("Auth access 5") }}
            <a :href="userLinks.userAgreement" target="_blank">{{
              $t("Auth access 6")
            }}</a>
          </div>
        </div>
      </div>
      <div class="demo__margin-top--16" v-if="installation === 'ru'">
        <div class="demo__flex demo__flex-middle demo__pointer">
          <a-checkbox
            v-model="form.marketing_consent"
            class="demo__Checkbox--big demo__Checkbox--white demo__margin-right--9"
          >
          </a-checkbox>
          <div
            class="demo__font--11 demo__weight--500 demo__color--black demo__line-height--normal"
          >
            {{ $t("Auth access 1") }}
            <a :href="userLinks.marketing_consent" target="_blank">{{
              $t("Auth access 7")
            }}</a>
          </div>
        </div>
      </div>
      <div
        class="demo__margin-top--24 demo__flex demo__flex-middle demo__flex-between"
      >
        <div class="demo__font--14 demo__weight--600">
          <span class="demo__color--black">
            {{ $t("Have account?") }}
          </span>
          <AuthLockBlock class="demo__inline">
            <span class="demo__color--brandPrimary demo__pointer">{{
              $t("Submit")
            }}</span>
          </AuthLockBlock>
        </div>

        <a-button
          class="demo__button demo__button--base"
          :disabled="nextStepDisabled"
          @click="changeStepTo2"
          data-testid="reg-next"
        >
          <span>
            {{ $t("To next") }}
          </span>
          <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
        </a-button>
      </div>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";
import IntlTelInputWithUtils from "Components/IntlTelInputWithUtils";
import { ru, en } from "intl-tel-input/i18n";
export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
  },
  components: {
    IntlTelInputWithUtils,
  },
  data() {
    return {
      emailPattern:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
      // phonePattern: /^\+\d{1}\s?\d{3}\s?\d{3}\s?\d{2}\s?\d{2}$/,
      // phonePattern: /^\+?\d+$/,
      imAgree: false,
      emailLoading: false,
      ru,
      en,
      hasEmailRegisteredError: undefined,
      lang: {},
      isPhoneValid: undefined,
      phoneError: undefined,
      errorCode: undefined,
      installation: process.env.VUE_APP_INSTALLATION,
    };
  },
  methods: {
    changeStepTo2() {
      this.$root.$emit("changeRegStep", 2);
      if (window.ym) {
        this.$root.$emit("reachGoal", {
          goalName: "signup",
          data: { step: 2 },
        });
        this.$debug("YA METRICS: событие signup with step 2", "ya_metric");
      }
    },
    async checkEmailRegistered(rule, value, callback) {
      this.emailLoading = true;
      this.hasEmailRegisteredError = undefined;
      await this.api
        .isRegistered({ data: { email: this.form.email } })
        .then((response) => {
          this.hasEmailRegisteredError = response.data?.status
            ? this.$t("EmailAlreadyRegistered")
            : undefined;
        })
        .catch((error) => {
          this.hasEmailRegisteredError =
            error.response?.status === 400
              ? error.response?.data?.detail || this.$t("Unexpected error")
              : this.$t("Unexpected error");
        })
        .finally(() => {
          this.emailLoading = false;
        });

      if (this.hasEmailRegisteredError) {
        callback([this.hasEmailRegisteredError]);
      }
    },
    loadIntlTelInputLang() {
      try {
        this.lang = this[this.$i18n.locale];
        this.$debug(
          `intl-tel-input: перевод для ${this.$i18n.locale} найден, используется ${this.$i18n.locale}  `
        );
      } catch (error) {
        this.$debug(
          `intl-tel-input: перевод для ${this.$i18n.locale} не найден, используется fallback (ru)`
        );
        this.lang = ru;
      }
    },
    validatePhone() {
      if (!this.form.phone) {
        this.phoneError = this.$t("Field required");
        return false;
      }

      if (!this.isPhoneValid) {
        this.phoneError = this.$t("Not valid phone");
        return false;
      }

      this.phoneError = "";
      return true;
    },
  },
  computed: {
    ...mapGetters(["userLinks", "api"]),
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
          {
            pattern: this.emailPattern,
            message: this.$t("Not valid email"),
            trigger: "change",
          },
          {
            validator: this.checkEmailRegistered,
            trigger: "blur",
          },
        ],
      };
    },
    nextStepDisabled() {
      return (
        !this.passwordValid ||
        !this.imAgree ||
        this.hasEmailRegisteredError ||
        this.emailLoading ||
        !!this.phoneError ||
        !this.isPhoneValid
      );
    },
    passwordValid() {
      return this.passwordRules.filter((rule) => !rule.valid).length === 0;
    },
    passwordRules() {
      return [
        {
          label: this.$t("Min 8"),
          valid: this.form.password && this.form.password.length >= 8,
        },
        {
          label: this.$t("1 char"),
          valid: /.*[A-Za-z].*/.test(this.form.password),
        },
        {
          label: this.$t("1 num"),
          valid: /.*[0-9].*/.test(this.form.password),
        },
      ];
    },
  },
  async created() {
    this.$accessModule("step1", this);
    await this.loadIntlTelInputLang();
  },
};
</script>
